import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PostsResolverService } from './providers/wordpress/posts-resolver.service';
import { PageResolverService } from './providers/wordpress/page-resolver.service';
import { ItemResolverService } from './providers/wordpress/item-resolver.service';

const routes: Routes = [
  { path: '', redirectTo: 'posts-list', pathMatch: 'full' },
  { path: 'walk', loadChildren: () => import('./pages/walkthrough/walkthrough.module').then(m => m.WalkthroughPageModule) },
  { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule) },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule) },
  { path: 'register', loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterPageModule) },
  { path: 'edit-profile', loadChildren: () => import('./pages/edit-profile/edit-profile.module').then(m => m.EditProfilePageModule) },
  { path: 'settings', loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule) },
 // { path: 'hotel-list', loadChildren: './pages/hotel-list/hotel-list.module#HotelListPageModule' },
 // { path: 'hotel-detail/:id', loadChildren: './pages/hotel-detail/hotel-detail.module#HotelDetailPageModule' },
 // { path: 'hotel-checkout/:hotelID/:roomID', loadChildren: './pages/hotel-checkout/hotel-checkout.module#HotelCheckoutPageModule' },
 // { path: 'booking-list', loadChildren: './pages/booking-list/booking-list.module#BookingListPageModule' },
 // { path: 'favorites', loadChildren: './pages/favorites/favorites.module#FavoritesPageModule' },
 // { path: 'local-weather', loadChildren: './pages/local-weather/local-weather.module#LocalWeatherPageModule' },
  { path: 'about', loadChildren: () => import('./pages/about/about.module').then(m => m.AboutPageModule) },
  { path: 'support', loadChildren: () => import('./pages/support/support.module').then(m => m.SupportPageModule) },
 // { path: 'messages', loadChildren: './pages/messages/messages.module#MessagesPageModule' },
 // { path: 'message/:id', loadChildren: './pages/message/message.module#MessagePageModule' },
 // { path: 'rentcar', loadChildren: './pages/rentcar/rentcar.module#RentcarPageModule' },
 // { path: 'cars-list', loadChildren: './pages/cars-list/cars-list.module#CarsListPageModule' },
 // { path: 'car-detail/:id', loadChildren: './pages/car-detail/car-detail.module#CarDetailPageModule' },
 // { path: 'car-checkout/:carshopID/:carID', loadChildren: './pages/car-checkout/car-checkout.module#CarCheckoutPageModule' },
 // { path: 'location', loadChildren: './pages/modal/location/location.module#LocationPageModule' },
 // { path: 'activities', loadChildren: './pages/activities/activities.module#ActivitiesPageModule' },
 // { path: 'activity-list', loadChildren: './pages/activity-list/activity-list.module#ActivityListPageModule' },
 // { path: 'activity-detail/:id', loadChildren: './pages/activity-detail/activity-detail.module#ActivityDetailPageModule' },
 // { path: 'activity-checkout/:tripID', loadChildren: './pages/activity-checkout/activity-checkout.module#ActivityCheckoutPageModule' },
  { path: 'card', loadChildren: () => import('./pages/card/card.module').then(m => m.CardPageModule) },
  { path: 'posts-list', 
    loadChildren: () => import('./pages/posts-list/posts-list.module').then(m => m.PostsListPageModule)
    , 
    resolve: {
      posts: PostsResolverService
    } 
  },
  { path: 'post-detail/:id', 
    loadChildren: () => import('./pages/post-detail/post-detail.module').then(m => m.PostDetailPageModule),
    resolve: {
      post: ItemResolverService
    },
  },
  { path: 'faq', loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqPageModule) },
  { path: 'rules', 
    loadChildren: () => import('./pages/rules/rules.module').then(m => m.RulesPageModule),
    resolve: {
      rules: PageResolverService
    },
    data: { postid: 27025 }
  },
  { path: 'map', loadChildren: () => import('./pages/map/map.module').then(m => m.MapPageModule) },
  { path: 'restaurants', 
    loadChildren: () => import('./pages/restaurants/restaurants.module').then(m => m.RestaurantsPageModule),
    resolve: {
      restaurants: PageResolverService
    },
    data: { postid: 26859 }
  },
  { path: 'contracts', loadChildren: () => import('./pages/contracts/contracts.module').then(m => m.ContractsPageModule) },
  { path: 'booking', loadChildren: () => import('./pages/booking/booking.module').then(m => m.BookingPageModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
